import { SET_ERROR, ErrorActionTypes } from './error.actions';

const initialState = {};

export default (state = initialState, action: ErrorActionTypes) => {
  const { type } = action;
  if (type === SET_ERROR) {
    return {
      ...state,
      [action.payload.action]: action.payload
    };
  }
  const matchesAPIAction = /(.*)_(API_REQUESTED|API_SUCCESS|API_FAILED)/.exec(type);
  if (matchesAPIAction) {
    const [, name, requestState] = matchesAPIAction;
    return {
      ...state,
      [name]: requestState === 'API_FAILED' ? action.payload : undefined
    };
  }
  return state;
};
